export default __webpack_public_path__ + "static/media/homepage-commuter-icon.715c0852.svg";